import { useApi, createApiHook } from "../utils/apiUtils";

const useSaveQuestionnaireJson = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const saveJson = async (questionnaireId, jsonData) => {
    startLoading();
    const response = await apiPost(`/questionnaires/${questionnaireId}/save-json`, "Error al guardar el JSON del cuestionario", {
      json_data: jsonData,
    });
    setResponse(response);

    if (response?.error) {
      const errorMessage = response.error.message || "No se pudo guardar el JSON del cuestionario";
      const err = new Error(errorMessage);
      err.backend = response.error;
      throw err;
    }
    return response?.data || null;
  };

  return { saveJson, data, loading, error };
};

export default useSaveQuestionnaireJson;
